import { SvgIcon, SvgIconProps } from "designSystem/index";
import React, { FunctionComponent } from "react";

const ShowPinIcon: FunctionComponent<SvgIconProps> = ({ ...props }) => {
	return (
		<SvgIcon {...props} viewBox="0 0 14 14">
			<path
				d="M5 13.6667C4.63333 13.6667 4.33333 13.3667 4.33333 13V11H1.66667C0.933334 11 0.333334 10.4067 0.333334 9.66668V1.66668C0.333334 0.926677 0.933334 0.333344 1.66667 0.333344H12.3333C13.0733 0.333344 13.6667 0.933343 13.6667 1.66668V9.66668C13.6667 10.4067 13.0733 11 12.3333 11H8.26667L5.8 13.4733C5.66667 13.6 5.5 13.6667 5.33333 13.6667H5ZM5.66667 9.66668V11.72L7.72 9.66668H12.3333V1.66668H1.66667V9.66668H5.66667ZM9.56 4.46668L8.88667 5.14001L7.50667 3.78668L8.18 3.10668C8.31333 2.96668 8.54 2.96001 8.7 3.10668L9.56 3.94001C9.7 4.08001 9.70667 4.30668 9.56 4.46668ZM4.33333 6.94001L7.11333 4.14668L8.49333 5.53334L5.72 8.33334H4.33333V6.94001Z"
				fill="#79818F"
				xmlns="http://www.w3.org/2000/svg"
			/>
		</SvgIcon>
	);
};

export default ShowPinIcon;